import { MyThunkResult } from 'store';

import { AccessLogResponse } from 'models/accessLog';

import { doLoadHasAccess, accessRequest } from '../action-creators/accessLog';
import { profile, axiosConfig } from '../api';

export const fetchHasAccess = (screen: string): MyThunkResult<Promise<void>> => (dispatch) => {
  dispatch(accessRequest());
  return profile.get<AccessLogResponse>(`AccessLog/GetAccessLog/${screen}`, axiosConfig).then((response) => {
    const { data } = response.data;
    const newData = {
      hasAccess: data.hasAccess,
      screenName: screen,
    };
    dispatch(doLoadHasAccess(newData));
  });
};
